class Socket {
    constructor(link, ...args) {
        if (link.constructor === WebSocket) {
            this.socket = link
        } else {
            this.socket = new WebSocket(link)
        }
        this.doOpen()
        this.readyState = this.socket.readyState
        this._events = {}
        this.heartBeatTimer = null
    }

    doOpen() {
        this.afterOpenEmit = []
        this.socket.addEventListener('open', evt => this.onOpen(evt))
        this.socket.addEventListener('message', evt => this.onMessage(evt))
        this.socket.addEventListener('close', evt => this.onClose(evt))
        this.socket.addEventListener('error', err => this.onError(err))
    }

    Notify(entry) {
        const cbQueue = this._events[entry.Event]
        if (cbQueue && cbQueue.length) {
            for (let callback of cbQueue) {
                if (callback instanceof Function) callback(entry.Data)
            }
        }
    }

    onOpen(evt) {
        this.Notify({Event: 'open', Data: evt})
    }

    /**
     * 订阅所有的数据
     * @param {array|object} datas 订阅参数集合
     */
    send(datas) {
        if (datas.constructor != Array) {
            datas = [datas]
        }
        for (let item of datas) {
            this.socket.send(JSON.stringify(item))
        }
    }

    onMessage(evt) {
        try {
            const data = JSON.parse(evt.data)
            this.Notify({
                Event: 'message',
                Data: data
            })
        } catch (err) {
            this.Notify({
                Event: 'error',
                Data: err
            })
        }
    }

    on(name, handler) {
        this.subscribe(name, handler)
    }

    off(name, handler) {
        this.unsubscribe(name, handler)
    }

    subscribe(name, handler) {
        if (this._events.hasOwnProperty(name)) {
            this._events[name].push(handler) // 追加事件
        } else {
            this._events[name] = [handler] // 添加事件
        }
    }

    unsubscribe(name, handler) {
        let start = this._events[name].findIndex(item => item === handler)
        this._events[name].splice(start, 1)
    }

    checkOpen() {
        return this.readyState >= 2
    }

    onClose(evt) {
        this.Notify({Event: 'close', Data: evt})
    }

    onError(err) {
        this.Notify({Event: 'error', Data: err})
    }

    emit(data) {
        return new Promise((resolve) => {
            this.send(JSON.stringify(data))
            this.on('message', function (data) {
                resolve(data)
            })
        })
    }

    doClose() {
        this.socket.close()
    }

    destroy() {
        if (this.heartBeatTimer) {
            clearInterval(this.heartBeatTimer)
            this.heartBeatTimer = null
        }
        this.doClose()
        this._events = {}
        this.readyState = 0
        this.socket = null
    }
}

export default Socket
